<template>
    <v-dialog v-model="exibirModalLogConfig"  max-width="95vw">
        <v-card style="max-width: 100%">
             <v-toolbar color="blue" class="mb-8">
                <v-flex  style="display: flex" class="pa-2">
                    <span style="width:95%;color:white;font-weight:bold;" >
                        Logs
                    </span>
                    <span style="width:5%">
                        <BotaoTutorial style="margin-right:30px;" urlVideo="" categoria="" legenda="Dúvidas Configurações Geral Checkin Pay"/>
                    </span> 
                    <span style="width:5%"> 
                        <v-btn x-small color="red" @click="setModalLogConfig()" title="Fechar">
                            <v-icon x-small style="color:white;">mdi-close</v-icon>
                        </v-btn>
                    </span>
                </v-flex>
            </v-toolbar>

            <v-card-text>
                   

                    <v-data-table v-if="listaLogs.length > 0"
                        :headers="headers"
                        :items="listaLogs"
                        class="elevation-1 ma-2"
                        no-data-text="Nenhuma Notificação Encontrada."

                        hide-actions
                        select-all
                        pagination.sync="pagination"
                        item-key="id"
                        loading="true"
                        
                    >
                    </v-data-table>
                    <div v-else>Sem Logs Por Enquanto</div>

                   

                    <div style="display:flex;justify-content:flex-end;margin-top:50px;">
                        <v-btn @click="setModalLogConfig()" data-cy="salvar" color="error" id="btn-cpay-salvar-gerais">
                            Fechar
                        </v-btn>
                    </div>

            </v-card-text>
            
                        
            
        </v-card>
    </v-dialog>
</template>          

<script>



export default {
    data: () => ({
        listaLogs:[],
        headers: [ 
                    { text: "Id", value: "id" , width:'10%' },
                    { text: "Alterado por", value: "apelido" , width:'10%' },
                    { text: "Data", value: "enviadoem", width:'20%' },
                    { text: "Dados", value: "dados", width:'60%'  },
                ],
                
    }),
    props:["exibirModalLogConfig","ListaChaveConfig"],
    components:{ 
    },
    methods: {
        setModalLogConfig(){
            this.$emit('setModalLogConfig')
        },
        buscarLogs(){

            this.$http.post("configuracao/buscarLog", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chaves" : this.ListaChaveConfig
            }).then(resp =>{
                // console.log('resp222222',reresp.dataresp.datasp)
                if(resp.status == 200){
                    console.log('respaaaa',resp.data)
                    this.listaLogs = resp.data
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })
        }
    },
    watch: {
        ListaChaveConfig: function(){
            this.buscarLogs()
        }
    },
    async mounted() {
        
        this.buscarLogs()
    },
};
</script>


<style scoped>
/* Customize the label (the container) */
.inputcheckbox {
    height:200px;
}

  .inputs{
    background-color:white;
    border-radius:15px;
    min-height:8vh;
    padding:5px 20px 5px 20px;
    border: 1px solid #819ab4;
  }

  .cardInputs{
    display:flex;
    flex-direction:column;
    justify-content:left;
    width:100%;
    margin-bottom:20px;
    /* background-color:red; */
    
  }

  
  .inputsHorario{
    background-color:white;
    text-align:center;
    border-radius:15px;
    min-height:8vh;
    font-size:25px;
    padding:10px;
    /* padding:5px 20px 5px 20px; */
    border: 1px solid #819ab4;
    width:100px; 
    margin-right: 20px;
    margin-top:10px;    
    
  }
</style>